export default __webpack_public_path__ + "static/media/ask2.935d30e1.svg";